import {
    getFlipStyle,
    getImageMaskStyle,
    getImageStyle,
    getImageTransformInfo,
    getInnerStyle,
} from '@/layers/image-layer/utils/layer';
import { IImageLayerProps, ILayerProps } from '@/version-types';
import ScaleAction from '../components/scale-action';
import CropGrid from './grid';
import './layer-operate.less';
import LayerResizeAction from './layer-resize-action';

const LayerOperate: React.FC<{
    layer: ILayerProps;
    scale: number;
    isAutoCutoutLayer: boolean;
}> = ({ layer, scale, isAutoCutoutLayer }) => {
    const {
        maskURL,
        imageTransform: { flipH, flipV, scale: imageScale, rotate },
        naturalWidth,
        naturalHeight,
        url,
        minimumMask,
    } = layer.data as IImageLayerProps;
    const { originImgWidth, originImgHeight, offsetX, offsetY } = getImageTransformInfo(layer);

    const flipStyle = getFlipStyle(flipH, flipV);
    const imageInnerStyle = getInnerStyle(
        originImgWidth * imageScale * scale,
        originImgHeight * imageScale * scale,
        offsetX * scale,
        offsetY * scale,
        rotate,
        imageScale,
        maskURL,
        layer.width * scale,
        layer.height * scale,
    );

    imageInnerStyle.transform = `translate(${offsetX * scale + ((layer.width - originImgWidth * imageScale) * scale) / 2}px, ${offsetY * scale + ((layer.height - originImgHeight * imageScale) * scale) / 2}px) rotate(${rotate}deg) scale(1)`;

    return (
        <div className="c-crop-image-layerOperate">
            <div
                className="layer-mask"
                style={{
                    ...getImageMaskStyle(maskURL ? maskURL : url, minimumMask),
                    maskSize: maskURL ? 'contain' : '',
                }}
            >
                <div style={flipStyle}>
                    <div style={imageInnerStyle}>
                        <img
                            crossOrigin="anonymous"
                            style={{
                                ...getImageStyle(
                                    originImgWidth * imageScale * scale,
                                    originImgHeight * imageScale * scale,
                                ),
                            }}
                            src={url}
                            width={naturalWidth}
                            height={naturalHeight}
                        />
                    </div>
                </div>
            </div>
            <ScaleAction rotate={layer.rotate} />
            <CropGrid />

            {isAutoCutoutLayer ? <LayerResizeAction /> : null}
        </div>
    );
};

export default LayerOperate;
